<template>
  <div>
    <DatePicker
      type="date"
      v-model="item.value0"
      :options="optionsStart"
      style="width: 110px"
      transfer
      :readonly="readonly"
    ></DatePicker>
    -
    <DatePicker
      type="date"
      v-model="item.value1"
      :options="optionsEnd"
      style="width: 110px"
      transfer
      :readonly="readonly"
    ></DatePicker>
  </div>
</template>
<script>
import props from './props'
export default {
  name: 'form-item-datetimerange',
  mixins: [props],
  data () {
    return {
      optionsStart: {
        disabledDate: (date) => {
          return date > new Date(this.item.value1) || date > Date.now()
        }
      },
      optionsEnd: {
        disabledDate: (date) => {
          return date < new Date(this.item.value0) || date > Date.now()
        }
      }
    }
  }
}
</script>